import { Toaster } from 'sonner';

import { useIsPhone } from '@/hooks/use-is-phone';

/** Top right on a wide screen; bottom centre on a phone, where the top bar would sit under it. */
export function PlatformToaster() {
  const isPhone = useIsPhone();

  return <Toaster position={isPhone ? 'bottom-center' : 'top-right'} richColors />;
}
